import { render, staticRenderFns } from "./MRRDynamic.vue?vue&type=template&id=19332942&scoped=true&"
import script from "./MRRDynamic.vue?vue&type=script&lang=js&"
export * from "./MRRDynamic.vue?vue&type=script&lang=js&"
import style0 from "./MRRDynamic.vue?vue&type=style&index=0&id=19332942&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19332942",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VContainer,VRow})
